var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-container"},[(_vm.rank)?_c('div',{staticClass:"badge-box"},[_c('span',{staticClass:"badge-text",style:(_vm.bgColor)},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }